import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { Component, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {
  passwordStrengthValidator,
  passwordsMatchValidator
} from '@core/shared/form-validators';
import { Subject, takeUntil } from 'rxjs';
import { UserApiService } from '@services/api/user/user/user-api.service';
import {ToastrServices} from '@services/toastr/toastr.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-change-password',
  imports: [ReactiveFormsModule, MaterialModule, CommonModule, TranslateModule, TablerIconsModule],
  templateUrl: './change-password.component.html',
  standalone: true,
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  change_password_form: FormGroup;
  protected readonly passwordMinLength = environment.password_min_length;
  hideOldPassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  private destroy$ = new Subject<void>();
  private user_api_service = inject(UserApiService);
  private toastr_service = inject(ToastrServices);

  constructor(private fb: FormBuilder) {
    this.change_password_form = this.fb.group({
      old_password: ['', Validators.required],
      new_password: ['', [Validators.required, Validators.minLength(this.passwordMinLength), passwordStrengthValidator()]],
      confirm_new_password: ['', Validators.required],
    }, { validators: passwordsMatchValidator('new_password', 'confirm_new_password')
    });
  }

  onSubmit(): void {
    if (this.change_password_form.valid) {
      this.user_api_service
        .changePassword(
          this.change_password_form.get('old_password')?.value,
          this.change_password_form.get('new_password')?.value,
          this.change_password_form.get('confirm_new_password')?.value
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            this.toastr_service.showSuccess('Passord updated succesfully', 'Success');
          },
          error: (error) => {
            console.error("Errore:", error);
            this.toastr_service.showError('Your old password is incorrect', 'Error');
            this.change_password_form.reset();
          }
        });
    } else {
      // console.log('Form is invalid.');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
